export enum WiDEObjectType {
    Group,
    Identifier,
    Rule,
    Script,
    GroupState,
    Trend,
    TrendSeries,
    Alarm
}